<template>
  <img
    class="flag"
    :class="{ small }"
    :src="getFlag(value)"
    :alt="value"
  >
</template>

<script>
import { AVAILABLE_COUNTRIES_FOR_LANGUAGES } from '@/scripts/constants/languages';

export default {
  name: 'LanguageFlag',

  props: {
    value: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getFlag(language) {
      const country = AVAILABLE_COUNTRIES_FOR_LANGUAGES.find(c => c.language === language);
      return `https://cdn.swordhealth.tech/assets/media/flags/${country.code}.svg`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .flag {
    height: .91875rem;
    border-radius: 2px;
    overflow: hidden;
    object-fit: cover;
    .small {
      height: 0.875em;
    }
  }
</style>
